import { FileText } from "lucide-react";

const Governance = () => (
  <section id="proof" className="bg-surface text-ink py-24 border-b border-line" data-testid="governance-section">
    <div className="max-w-7xl mx-auto px-6">
      <p className="font-mono text-xs uppercase text-brand tracking-widest mb-2">Verified Track Record</p>
      <h2 className="font-display text-[clamp(32px,4vw,56px)] uppercase mb-12 tracking-wide">
        Procurement Governance Audit
      </h2>

      <div className="border border-line p-8 bg-night text-center" data-testid="governance-empty-state">
        <FileText className="w-8 h-8 text-mute mx-auto mb-4" strokeWidth={1.5} />
        <p className="text-sm font-mono text-mute uppercase tracking-wider max-w-2xl mx-auto">
          Audited performance reports from certified participating vendors and
          landlords will publish here upon completion of the current fiscal tender cycle.
        </p>
      </div>
    </div>
  </section>
);

export default Governance;
